export default {
    en: {
        STATS_TITLE: "Stats",
        STATS_EXPORT: "Export Stats",
        STATS_RESULTS_TITLE: "Result", 
        STATS_COMPETITION_TITLE: "Competition",
        STATS_METRICS_TITLE: "Metrics",

        STATS_COMPETITION_NAME_KEY: "Name",
        STATS_ORG_NAME_KEY: "Organization",
        STATS_START_DATE_KEY: "Start Date",
        STATS_END_DATE_KEY: "End Date",
        STATS_NUMBER_OF_PLAYERS_KEY: "Number of players",
        STATS_NUMBER_OF_TEAMS_KEY: "Number of teams",
        STATS_NUMBER_OF_CHALLENGES_KEY: "Number of challenges",
        STATS_NUMBER_OF_UNSOLVED_CHALLENGES_KEY: "Number of unsolved challenges",
        STATS_TOTAL_NUMBER_OF_SUBMISSIONS_ATTEMPTS_KEY: "Number of attempts",
        STATS_TOTAL_CORRECT_SUBMISSIONS_KEY: "Number of correct submissions",
        STATS_PERCENTAGE_OF_SUCCESS_KEY: "Success rate",
        STATS_TOTAL_POSSIBLE_SCORE: "Total possible score",
        STATS_TOP_SCORE_KEY: "Top score",
        STATS_MEDIAN_SCORE_KEY: "Median score",
        STATS_INPUT_TOKEN_KEY: "Input tokens",
        STATS_OUTPUT_TOKEN_KEY: "Output tokens",
        STATS_TOTAL_TOKEN_KEY: "Total tokens",

        STATS_RANK_WINNER_LABEL: "Winner",
        STATS_RANK_RUNNERUP_LABEL: "Runner-up",
        STATS_RANK_THIRD_LABEL: "Third place",
    }
}
